<script setup lang="ts">
    useSeoMeta({
        title: "個人情報保護方針｜株式会社Bang",
        description: "株式会社Bangの個人情報保護方針を掲載しています。",
        ogTitle: "個人情報保護方針｜株式会社Bang",
        ogDescription: "株式会社Bangの個人情報保護方針を掲載しています。",
        ogUrl: "https://www.bang-inc.jp/info/privacy",
    });

    const breadcrumbsItems = [
        { text: "トップページ", href: "/" },
        { text: "個人情報保護方針", href: "/info/privacy" },
    ];
</script>

<template>
  <main class="terms">
    <!-- パンくずリスト -->
    <Breadcrumbs :items="breadcrumbsItems" />
    <div class="terms__body">
    <HeadingCorp :level="1">個人情報保護方針</HeadingCorp>
    <section class="terms__section">
        <p class="terms__section-text">
            当社は、個人情報保護の重要性に鑑み、また、業務に従事するすべての者が、その責任を認識し、個人情報の保護に関する法律（個人情報保護法）その他の関連法令・ガイドラインを遵守して、個人情報を適正に取り扱うとともに、安全管理について適切な措置を講じます。
        </p>
        <p class="terms__section-text">
            当社は、個人情報の取扱いに関する従業者への教育・指導を徹底し、適正な取扱いが行われるよう取り組んでまいります。また、個人情報の取扱いに関する苦情・相談に迅速に対応し、当社の個人情報の取扱い及び安全管理に係る適切な措置については、適宜見直し改善いたします。
        </p>
    </section>

      <!-- 1 -->
      <section class="terms__section">
        <HeadingCorp :level="2">（１）個人情報の取得</HeadingCorp>
        <p class="terms__section-text">
            当社は、十分な安全管理措置を講じたうえで、業務上必要な範囲で、適法かつ公正な手段により個人情報を取得します。
        </p>
      </section>

      <!-- 2 -->
      <section class="terms__section">
        <HeadingCorp :level="2">（２）個人情報の利用目的</HeadingCorp>
        <p class="terms__section-text">
            当社は、取得した個人情報を、当社の営む損害保険代理業に関する商品およびこれらに付帯・関連するサービスの提供等、ならびに下記の各保険会社の委託を受けて行う各社の保険およびこれらに付帯・関連するサービスの提供等に係る業務遂行に必要な範囲内で利用します。その他の目的に利用することはありません。
        </p>
        <p class="terms__section-text">
            上記の利用目的の変更は、関連性を有すると合理的に認められる範囲においてのみ行い、変更する場合には、その内容をご本人に対し、原則として書面等により通知し、またはホームページ（ＵＲＬ）等により公表します。
        </p>
        <p class="terms__section-text">
            当社に対し保険募集業務の委託を行う保険会社の利用目的は、各社のホームページ（以下）に掲載してあります。<br>
            日新火災海上保険株式会社（<a href="https://www.nisshinfire.co.jp" target="_blank">https://www.nisshinfire.co.jp</a>）<br>
            チューリッヒ保険会社（<a href="https://www.zurich.co.jp/fire/" target="_blank">https://www.zurich.co.jp/fire/</a>）<br>
            ジェイアイ傷害火災保険株式会社（<a href="https://www.jihoken.co.jp/service/#ieho" target="_blank">https://www.jihoken.co.jp/service/#ieho</a>）<br>
            ソニー損害保険株式会社（<a href="https://www.sonysonpo.co.jp/fire/" target="_blank">https://www.sonysonpo.co.jp/fire/</a>）
        </p>
      </section>

      <!-- 3 -->
      <section class="terms__section">
        <HeadingCorp :level="2">（３）個人データの安全管理措置</HeadingCorp>
        <p class="terms__section-text">
            当社は、取扱う個人データの漏えい、滅失またはき損の防止その他の個人データの安全管理のため、以下のとおり対策を講じています。<br>
            （基本方針の策定）当社の個人情報取扱規程に基づき、本書において、当社の名称、安全管理措置に関するご照会及び苦情受付の窓口、個人データの安全管理に関する宣言、基本方針の継続的改善の宣言、関係法令遵守の宣言、等についての基本方針を策定<br>
            （個人データの取扱いに係る規律の整備）当社の個人情報取扱規程において、個人データの取得、利用、保存等を行う場合の基本的な取扱方法を整備<br>
            （組織的安全管理措置）個人情報の管理に関する責任者の設置、個人情報の取扱状況の点検および監査体制の整備と実施、漏えい事案等に対する態勢の整備、等を実施<br>
            （人的安全管理措置）従業者との「非開示契約」の締結、就業規則等の整備、従業者への周知徹底および研修、等を実施<br>
            （物理的安全管理措置）紛失・盗難を防ぐための書類・外部媒体等の施錠保管、個人情報廃棄時の裁断・焼却・溶解・消去、データ管理者の承諾なく個人情報を持ち運ぶことの禁止、持ち運ぶ場合の件数制限、等の措置を実施<br>
            （技術的安全管理措置）不正アクセスを防止するための強固なパスワードの使用、IDの共有禁止、暗号化設定可能な機器の使用、等の措置を実施
        </p>
      </section>

      <!-- 4 -->
      <section class="terms__section">
        <HeadingCorp :level="2">（４）個人データの第三者への提供および第三者からの取得について</HeadingCorp>
        <p class="terms__section-text">
            当社は、以下の場合を除き、ご本人の同意なく第三者に個人データを提供しません。
        </p>
        <ul class="terms__list">
            <li class="terms__number-item">①法令に基づく場合 </li>
            <li class="terms__number-item">②人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
            <li class="terms__number-item">③公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき</li>
            <li class="terms__number-item">④国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
            <li class="terms__number-item">⑤当該第三者が学術研究機関等である場合であって、当該第三者が当該個人データを学術研究目的で取り扱う必要があるとき（当該個人データを取り扱う目的の一部が学術研究目的である場合を含み、個人の権利利益を不当に侵害するおそれがある場合を除く）</li>
        </ul>
        <p class="terms__section-text">
            また、個人データを第三者に提供したとき、あるいは第三者から取得したとき、提供・取得経緯等確認を行うとともに、提供先・提供者の氏名等、法令で定める事項を記録し、保管します。
        </p>
      </section>

      <!-- 5 -->
      <section class="terms__section">
        <HeadingCorp :level="2">（５）センシティブ情報の取扱い</HeadingCorp>
        <p class="terms__section-text">
            当社は、要配慮個人情報（人種、信条、社会的身分、病歴、前科・前歴、犯罪被害情報などをいいます）ならびに労働組合への加盟、門地および本籍地、保健医療および性生活に関する情報（「センシティブ情報」といいます）を、個人情報保護法その他の法令、ガイドラインに規定する場合を除くほか、取得、利用または第三者提供しません。
        </p>
      </section>

      <!-- 6 -->
      <section class="terms__section">
        <HeadingCorp :level="2">（６）当社に対するご照会</HeadingCorp>
        <p class="terms__section-text">
            下記お問い合わせ窓口にお問い合わせください。また保険事故に関するご照会については、下記お問い合わせ窓口のほか、保険証券に記載の事故相談窓口にお問い合わせください。<br>
            ご照会者がご本人であることをご確認させていただいたうえで、対応させていただきますので、あらかじめご了承願います。
        </p>
        <p class="terms__section-text">
        【お問い合わせ窓口】
        <span class="terms__address">
            代理店（所在地）東京都世田谷区三軒茶屋2丁目11番22号４F<br>
            （名称）株式会社Bang<br>
            （代表者）長山　真己<br>
            （電子メールアドレス）：<a href="mailto:info@bang-inc.jp">info@bang-inc.jp</a><br>
            （ホームページアドレス）：<a href="/">https://www.bang-inc.jp/</a>
        </span>
        </p>
      </section>
    </div>
  </main>
</template>

<style scoped lang="scss">
.terms {
    position: relative;
    width: min(91vw, 64.5rem);
    margin: auto;
    &::before {
        content: '';
        position: absolute;
        width: 20rem;
        height: 20rem;
        aspect-ratio: 1/1;
        left: -4rem;
        top: -3rem;
        border-radius: 20rem;
        box-sizing: border-box;
        border: 1.5rem solid #EFF7FF;
        z-index: -1;
        pointer-events: none;
    }
    &__body {
        padding: 2rem 0 4.5rem;
    }
    &__section {
        line-height: 150%;
        &:not(:last-child) {
            margin-bottom: 2.5rem;
        }
        a[href] {
            color: #2174C0;
            text-decoration: underline;
            overflow-wrap: anywhere;
            &:hover {
                opacity: 0.48;
                transition: opacity 0.3s ease;
            }
        }
    }
    &__section-text {
        &:not(:last-child) {
            margin-bottom: 0.25rem;
        }
    }
    &__number-item {
        margin-bottom: 0.25rem;
        text-indent: -1rem;
        padding-left: 1rem;
    }
    &__address {
        display: block;
        text-indent: -3rem;
        padding-left: 3rem;
    }
}

@include mixin.media(pc) {
    .terms {
        &::before {
            width: 32.5rem;
            height: 32.5rem;
            left: -10.7rem;
            top: -4rem;
            border-radius: 32.5rem;
            border: 2.5rem solid #EFF7FF;
        }
        &__body {
            padding: 4rem 0 5rem;
        }
        &__section {
            &:not(:last-child) {
                margin-bottom: 3rem;
            }
        }
    }
}
</style>
